module.exports = __webpack_public_path__ + "media/new1.a9d6dd2e.mp4";